import { useServiceUrl, ServiceKey } from '@matillion/hub-client'

export const useDesignerUrl = (): string => {
  return useServiceUrl(ServiceKey.designerFrontend, true)
}
